import { OmitStrict } from '@tink/core/src/types';
import { ajaxRetry } from '../../../../lib-api/ajaxRetry';
import { TransferAccountsEntity } from '../../../models/account';
import { CreateTransferRequest, TransfersEntity } from '../../../DirectPayments/models/transfer';

import { base, createApiURL, ResponseObj } from '../../../../lib-api/services/base';

export const getAccounts = (
  paymentRequestId: string
): Promise<ResponseObj<TransferAccountsEntity>> => {
  return ajaxRetry<TransferAccountsEntity>({
    headers: base.headers(),
    method: 'GET',
    url: createApiURL(`/api/v1/transfer/accounts?paymentRequestId=${paymentRequestId}`),
  });
};

export const createTransfer = (
  requestId: string,
  request: OmitStrict<CreateTransferRequest, 'requestId'>
): Promise<ResponseObj<TransfersEntity | undefined>> => {
  return ajaxRetry({
    data: JSON.stringify(request),
    headers: base.headers(),
    method: 'POST',
    url: createApiURL(`/api/v1/transfer/payments/requests/execute/${requestId}`),
  });
};

export const getTransferStatus = (
  transferId: string
): Promise<ResponseObj<TransfersEntity | undefined>> => {
  return ajaxRetry({
    data: JSON.stringify({ transferId }),
    headers: base.headers(),
    method: 'GET',
    url: createApiURL(`/api/v1/transfer/${transferId}/data`),
  });
};
